import Enum from '@/modules/core/app/helpers/Enum';
import { AnnouncementContentTypeKey } from '@/modules/announcement/constants/AnnouncementContentTypeKey';
import Lang from '@/modules/core/app/services/Lang';

export class AnnouncementContentType extends Enum {
  key!: string;
  value!: string;

  static IMAGE: AnnouncementContentType = {
    key: AnnouncementContentTypeKey.IMAGE,
    get value(): string {
      return Lang.t('announcement.content-type-image');
    }
  };

  static SCRIBE: AnnouncementContentType = {
    key: AnnouncementContentTypeKey.SCRIBE,
    get value(): string {
      return Lang.t('announcement.content-type-scribe-url');
    }
  };
}
